import React from 'react';
import { Box } from '@mui/material';

const Factor6Logo = ({ width = '400px', height = 'auto' }) => {
  return (
    <Box sx={{ height, width }}>
      <img src="/assets/Factor6_E-learning_Logo_Blue.svg" alt="Factor6 Learning" />
    </Box>
  );
};

export default Factor6Logo;
